import { createFileRoute } from "@tanstack/react-router"
import { lazy, Suspense } from "react"
import type View3dType from "@/features/projects/visualization/View3d"

// Precisely type the lazy component to include its props
const View3dLazy = lazy<typeof View3dType>(() => import("@/features/projects/visualization/View3d"))

export const Route = createFileRoute("/(authenticated)/projects/edit/$projectId/3d")({
  component: View3dRouteComponent,
})

function View3dRouteComponent() {
  const params = Route.useParams()
  return (
    <Suspense fallback={<div className="p-4 text-sm">Loading 3D…</div>}>
      <View3dLazy params={params} />
    </Suspense>
  )
}
